import { Component } from '@angular/core';

@Component({
    selector: 'app-qrscan',
    templateUrl: './qrscan.component.html',
    styleUrls: ['./qrscan.component.scss'],
    standalone: false
})
export class QRScanComponent {
}
